import $ from 'jquery';
import nearestClubService from 'framework/services/nearestClubService';
import Framework from 'framework';

let prospectClubHeaderEl = $('#prospectGeolocation');
let prospectCurrentEl = prospectClubHeaderEl.find('#prospectCurrentLoc');
let prospectNearbyEl = prospectClubHeaderEl.find('#prospectNearbyLoc');

function makeClubLink(club) {
	const comingSoon = club.description ? '(' + club.description + ')' : '';
	const distance = club.distance ? club.distance : '0.0';
	return `<a href="${club.prospectPagePath}">${club.name}</a> ${comingSoon} (${distance} miles)`;
}

function updateClubLinks(club) {
	//current club
	prospectCurrentEl.html(makeClubLink(club));

	const nearestClubQuery = {
		distance: 50,
		limit: 4,
		cId: club.id
	};

	let nearestList = '<li class="m-b-sm">No clubs found within 50 miles.</li>';

	nearestClubService.getNearestClubs(nearestClubQuery).then((data)=> {
		if(data && data.length) {
			data.shift(); // remove first element (this club) so we're left with max 3 nearby clubs
			const nearestClubs = data;

			if(nearestClubs.length > 0) {
				nearestList = '';
				$.each(nearestClubs, function( index, nearby ) {
					nearestList += '<li class="m-b-sm">' + makeClubLink(nearby) + '</li>';
				});
			}
		}
	})
	.finally(() => {
		prospectNearbyEl.html(nearestList);
	});
}

if(!Framework.global.lt.pageProperties.disableProspectGeoLocation) {
	window.ef.prospectProfileStore.listen((profile) => {
		updateClubLinks(profile.club);
	});
}
